/**
 * Products API Module
 *
 * Danh mục sản phẩm của bản CTV là BẢN SAO từ CMS tổng: xưởng chỉ may được những
 * gì tổng có, nên CTV không tạo/xoá/sửa sản phẩm. Backend đã XOÁ hẳn
 * `POST /products`, `DELETE /products/{id}` và `POST /products/{id}/image`
 * (gọi vào trả 405) — đừng dựng lại hàm gọi chúng ở đây.
 *
 * Thứ duy nhất CTV đặt được là GIÁ BÁN cho khách cuối (`update`), và admin kéo
 * danh mục mới về bằng `syncCatalog`.
 */

import apiClient, { extractData } from '../api-client';

export const productApi = {
  /**
   * List all products with pagination
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number (default: 1)
   * @param {number} params.size - Page size (default: 20, max: 100)
   * @param {string} params.search - Search term
   * @param {boolean} params.is_active - Filter by active status
   * @returns {Promise<Object>} Paginated response with products
   */
  list(params) {
    return apiClient.get('/products', { params }).then(extractData);
  },

  /**
   * Tag vải trong danh mục (tổng nhập) — lựa chọn của bộ lọc đơn theo vải
   * @returns {Promise<string[]>}
   */
  fabricTags() {
    return apiClient.get('/products/fabric-tags').then(extractData);
  },

  /**
   * Get product by ID
   * @param {number} productId - Product ID
   * @returns {Promise<Object>} Product response
   */
  getById(productId) {
    return apiClient.get(`/products/${productId}`).then(extractData);
  },

  /**
   * Đặt GIÁ BÁN của CTV cho một sản phẩm.
   *
   * Backend CHỈ nhận `price`: field khác gửi lên bị bỏ qua (lần đồng bộ kế tiếp
   * ghi đè tên/mã/ảnh/cân nặng từ tổng), thiếu `price` trả 400 "Thiếu giá bán".
   *
   * @param {number} productId - Product ID
   * @param {Object} productData - `{ price }`
   * @returns {Promise<Object>} Updated product response
   */
  update(productId, productData) {
    return apiClient.put(`/products/${productId}`, productData).then(extractData);
  },

  /**
   * Kéo danh mục mới nhất từ CMS tổng về (chỉ admin).
   *
   * Giá bán CTV đã đặt được giữ nguyên. Lỗi cấu hình/kết nối trả 400 kèm
   * `detail` tiếng Việt — hiện thẳng detail đó cho người dùng.
   *
   * @returns {Promise<Object>} `{ message, them, cap_nhat, nhan_nuoi, an_di }`
   */
  syncCatalog() {
    return apiClient.post('/products/sync-catalog').then(extractData);
  },

  /**
   * Đồng bộ NGẦM lúc mở form tạo đơn (ai tạo được đơn cũng gọi được).
   *
   * Tổng ghi nợ theo giá sỉ của tổng lúc nhận đơn, nên giá CTV đang nhìn phải
   * mới. Backend không báo lỗi (hỏng trả `{ ok: false }`), form vẫn mở bình thường.
   *
   * @returns {Promise<Object>} `{ ok, them?, cap_nhat?, nhan_nuoi?, an_di? }`
   */
  syncCatalogSilent() {
    return apiClient.post('/products/sync-catalog/silent').then(extractData);
  }
};
